export default [
  // TODO: add BAD_SERVICE
  {
    title: 'I received the wrong order',
    icon: '$vuetify.icons.random',
    reason: 'WRONG_ORDER'
  },
  {
    title: 'The food I received was bad',
    icon: '$vuetify.icons.hamburger',
    reason: 'BAD_FOOD'
  },
  {
    title: 'I had an issue with a promo code',
    icon: '$vuetify.icons.tag',
    reason: 'PROMO_CODE'
  },
  {
    title: 'There was another issue',
    icon: '$vuetify.icons.frown',
    reason: 'OTHER'
  }
]
